export function FacebookIcon({ className = "" }) {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.99246 0C2.95799 0 0.514648 2.44334 0.514648 5.47781V24.5222C0.514648 27.5566 2.95799 30 5.99246 30H16.3143V18.2719H13.2131V14.0494H16.3143V10.4419C16.3143 7.60762 18.1467 5.00531 22.3677 5.00531C24.0768 5.00531 25.3406 5.16938 25.3406 5.16938L25.2412 9.11251C25.2412 9.11251 23.9523 9.10033 22.5459 9.10033C21.0237 9.10033 20.7796 9.80167 20.7796 10.966V14.0494H25.3621L25.1624 18.2719H20.7796V30H25.0368C28.0712 30 30.5146 27.5567 30.5146 24.5222V5.47784C30.5146 2.44338 28.0712 2.99999e-05 25.0368 2.99999e-05H5.99243L5.99246 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
